import { BaseModel } from "./base-model";

export class RefModel extends BaseModel {}
